import type { NatsConnection, NatsError } from "nats.ws";

export interface NatsInternalConnection {
  protocol?: { lastError?: NatsError };
}

// reaching into nats internals to get the error message, no public API for it
export function lastError(connection: NatsConnection): NatsError | undefined {
  return (connection as NatsInternalConnection).protocol?.lastError;
}
